{
  "checkedInTitle": "Ya te has registrado",
  "postCheckInInstructions": "Instrucciones posteriores al registro",
  "appointmentDetails": "Detalles de la cita",
  "notifyWarehouse": "Le informamos al almacén que llegaste para que puedan verificar su disponibilidad",
  "waitForStaff": "Por favor espera más instrucciones del personal del almacén",
  "unplannedDescription": "Parece que no tienes una cita. Por favor espera más instrucciones del personal del almacén.",
  "whatsappDelay": "El primer mensaje de WhatsApp puede tardar hasta un minuto en llegar.",
  "bookNextTitle": "Reserva una cita para la próxima vez",
  "bookNextBody": "Regístrate en Opendock para poder reservar una cita la próxima vez que vengas a esta instalación",
  "helpFooter": "Si necesitas ayuda o información adicional, por favor contacta al personal del almacén",
  "finalize": "Finalizar ({seconds})"
}
